import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum POLineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, refernce ID, etc
  description = 'description', // verbose description of the item (human parseable)
  itemQty = 'itemQty', // quantity of the item for order
  unitPrice = 'unitPrice', // price per unit
  lineTotal = 'lineTotal', // total cost per (unitPrice * itemQty), not to be entered by user
}

export const purchaseOrderFileDataSchema = yup.object().shape({
  buyer: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  purchaseOrderNumber: yup.string().nullable().optional(),
  externalReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateReady: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  vendor: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  destination: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    contactName: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  taxRate: yup.string().nullable().optional(),
  shippingFee: yup.string().nullable().optional(),
  otherFees: yup.string().nullable().optional(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
  signature: yup.string().nullable().optional(),
})

export type PurchaseOrderFileData = yup.InferType<typeof purchaseOrderFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<PurchaseOrderFileData>

export const purchaseOrderFileMappings: RequiredFileData = {
  buyer: {
    companyName: '40a1b051-268c-45aa-84c1-d32af78b253f',
    address: '6350cecb-427d-496b-8cc4-b114b4ad892b',
    contactName: '43606080-d4a2-4193-8c06-96e41262b9a7',
    phoneNumber: '12c6d351-b9ab-492c-b54b-64333ee577e5',
    emailAddress: '2179395d-11ab-4476-887e-3249cb8a82f3',
  },
  purchaseOrderNumber: '72f9e965-0349-42a3-b52b-8c1b7cb6f60c',
  externalReferenceNumber: '2e06c61c-e4bd-4640-8abd-31db34078485',
  paymentTerms: '2c9726a3-1d2a-4e77-9f7c-46637f7c6ccf',
  freightTerms: 'fa390653-034c-4770-af43-e9123889518c',
  dateIssued: 'ce1e0c1f-689e-4a33-8302-c7f62264ec1a',
  dateReady: '5abccc0a-bf2c-4fc4-86f7-1d3ba5e0a418',
  vendor: {
    companyName: '8c390353-6da7-48d0-a66c-57310d1bd6d0',
    address: 'ce3f1f14-9277-4c94-b5ad-70f3d22f5a10',
    contactName: 'be0b4e19-3ca4-44ce-81d5-11e8775deec7',
    phoneNumber: '6a7d943d-e67b-4388-8767-7bf8f1c9740b',
    emailAddress: '41193791-e09d-42eb-b499-33f9a05af81e',
  },
  destination: {
    companyName: 'c53a2c43-12fa-4e5e-a6d9-2e4bfb1379da',
    address: '498f4fbb-e27b-44c4-b679-799bc17615be',
    contactName: 'e18a6954-1989-452f-8dc4-66fb6d685325',
    phoneNumber: '1d7cc29f-f233-4c11-beec-db8fcfc02bc6',
    emailAddress: 'b26795ca-d0c4-4d6a-b56e-3a41bb1ab211',
  },
  items: [
    {
      itemNumber: null,
      itemName: '3612ec26-df10-47af-8385-caedcea8758e',
      description: '9996a903-d7ff-4e06-be8f-1dca4a7a47ce',
      itemQty: '82e1b08c-4e96-43af-9f40-d443c52bbda6',
      unitPrice: 'e6d61df0-36cc-4164-88bf-27b22e045c1d',
      lineTotal: null,
    },
  ],
  taxRate: 'b4eccc34-14f3-41b3-bf95-a886e7d86fbe',
  shippingFee: '273137cb-d930-45e4-8270-7b3391932085',
  otherFees: '6bae27fd-7aa0-44ff-828e-786bccd66181',
  agreement: 'eef25fb6-8c19-4bfa-9974-262538e3b1b9',
  instructions: 'eea37461-59fd-41fc-aa2a-06d03429df89',
  signature: 'b03986d3-3d96-439a-a067-f139c1beb9df',
}
